module.exports = __webpack_public_path__ + "img/bg_8.549b38e6.jpg";